import { getStat } from '@/api'
import { getCurrentUserInfo } from '@/api/mine'
export default {
    namespaced:true,
    state: {//state
        user: {},
        stat: {},
    },
    mutations: {
        setUser(state,user) {
            state.user = user
        },
        setStat(state,stat){
            state.stat = stat
        },

    },
    actions: {
        async getUser({commit,state}) {
            const { success, data } = await getCurrentUserInfo()
            if (success) commit('setUser', data)
            return data
        },
        getStat({commit,state}) {
            getStat().then(res => {
                if (res.success) {
                    commit('setStat', res.data)
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/store/user.js